import React from 'react';
import './LegalApp.css';

// Desktop counterpart to src/mobile/components/ToggleSwitch.js - same green/red
// Pending/Completed styling, used on the Evidence, SOP, and Interrogation
// Questions tables in InvestigateFIR.js.
const ToggleSwitch = ({ checked, onChange, disabled }) => (
  <button
    type="button"
    role="switch"
    aria-checked={checked}
    disabled={disabled}
    onClick={(e) => {
      e.stopPropagation();
      onChange();
    }}
    className={`d-toggle ${checked ? 'on' : 'off'}`}
  >
    <span className="d-toggle-thumb" />
  </button>
);

export default ToggleSwitch;
